import {
  COMPANY_SUMMARY_ANCHOR,
  COMPANY_VALUE_ANCHOR,
  COMPANY_FUTURE_ANCHOR,
  COMPANY_PAST_ANCHOR,
  COMPANY_HEALTH_ANCHOR,
  COMPANY_DIVIDEND_ANCHOR,
  COMPANY_MANAGEMENT_ANCHOR,
  COMPANY_OWNERSHIP_ANCHOR,
  COMPANY_INFORMATION_ANCHOR,
} from '@/constants/anchors';
import { useMedia } from '@/hooks/useMedia/useMedia';
import { useTranslation } from '@/hooks/useTranslation';
import { useMemo } from 'react';
import { useTheme } from 'styled-components';

export const useRoutes = () => {
  const theme = useTheme();
  const isMDScreen = useMedia(`(max-width: ${theme.lgMaxRaw}px)`);
  const t = useTranslation();

  return useMemo(
    () =>
      [
        {
          anchor: COMPANY_SUMMARY_ANCHOR,
          tracking: 'Executive Summary',
          label: isMDScreen
            ? t('page.companyReport.sidebar.overview')
            : t('page.companyReport.sidebar.overviewLong'),
        },
        {
          anchor: COMPANY_VALUE_ANCHOR,
          tracking: 'Valuation',
          label: t('page.companyReport.sidebar.valuation'),
        },
        {
          anchor: COMPANY_FUTURE_ANCHOR,
          tracking: 'Future Growth',
          label: isMDScreen
            ? t('page.companyReport.sidebar.future')
            : t('page.companyReport.sidebar.futureLong'),
        },
        {
          anchor: COMPANY_PAST_ANCHOR,
          tracking: 'Past Performance',
          label: isMDScreen
            ? t('page.companyReport.sidebar.past')
            : t('page.companyReport.sidebar.pastLong'),
        },
        {
          anchor: COMPANY_HEALTH_ANCHOR,
          tracking: 'Financial Health',
          label: isMDScreen
            ? t('page.companyReport.sidebar.health')
            : t('page.companyReport.sidebar.healthLong'),
        },
        {
          anchor: COMPANY_DIVIDEND_ANCHOR,
          tracking: 'Dividend',
          label: t('page.companyReport.sidebar.dividend'),
        },
        {
          anchor: COMPANY_MANAGEMENT_ANCHOR,
          tracking: 'Management',
          label: t('page.companyReport.sidebar.management'),
        },
        {
          anchor: COMPANY_OWNERSHIP_ANCHOR,
          tracking: 'Ownership',
          label: t('page.companyReport.sidebar.ownership'),
        },
        {
          anchor: COMPANY_INFORMATION_ANCHOR,
          tracking: 'Company Information',
          label: isMDScreen
            ? t('page.companyReport.sidebar.information')
            : t('page.companyReport.sidebar.informationLong'),
        },
      ] as const,
    [isMDScreen, t]
  );
};
